"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Loading = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "loading", viewBox: "0 0 20 20", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "loading", fill: "none", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M19.297 10.703a.703.703 0 0 1-.703-.703c0-1.16-.227-2.285-.676-3.346a8.605 8.605 0 0 0-1.842-2.732A8.55 8.55 0 0 0 10 1.406.703.703 0 1 1 10 0c1.35 0 2.66.264 3.893.787A9.93 9.93 0 0 1 17.07 2.93a9.982 9.982 0 0 1 2.143 3.177A9.936 9.936 0 0 1 19.998 10a.7.7 0 0 1-.701.703Z", fill: "#000", fillOpacity: ".85" }) })) })));
};
exports.Loading = Loading;
